import { GET_CONSIGNEE_REQUEST, GET_CONSIGNEE_SUCCESS, GET_CONSIGNEE_FAIL,
    CREATE_CONSIGNEE_REQUEST, CREATE_CONSIGNEE_SUCCESS, CREATE_CONSIGNEE_FAIL,
    UPDATE_CONSIGNEE_REQUEST, UPDATE_CONSIGNEE_SUCCESS, UPDATE_CONSIGNEE_FAIL,
    DELETE_CONSIGNEE_REQUEST, DELETE_CONSIGNEE_SUCCESS, DELETE_CONSIGNEE_FAIL,
} from "../types/consigneeMasterTypes";



function getConsigneeReducer( state = { consignee: []}, action) {
    switch (action.type) {
        case GET_CONSIGNEE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_CONSIGNEE_SUCCESS:
            return {
                ...state,
                consignee: action.payload,
                isLoading: false
            }       
        case GET_CONSIGNEE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function createConsigneeReducer( state = { createConsignee: {}}, action) {
    switch (action.type) {
        case CREATE_CONSIGNEE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_CONSIGNEE_SUCCESS:
            return {
                ...state,
                createConsignee: action.payload,
                isLoading: false
            }       
        case CREATE_CONSIGNEE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateConsigneeReducer( state = { updateConsignee: {}}, action) {
    switch (action.type) {
        case UPDATE_CONSIGNEE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_CONSIGNEE_SUCCESS:
            return {
                ...state,
                updateConsignee: action.payload,
                isLoading: false
            }       
        case UPDATE_CONSIGNEE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function deleteConsigneeReducer( state = { deleteConsignee: {}}, action) {
    switch (action.type) {
        case DELETE_CONSIGNEE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_CONSIGNEE_SUCCESS:
            return {
                ...state,
                deleteConsignee: action.payload,
                isLoading: false
            }       
        case DELETE_CONSIGNEE_FAIL :
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}




export { getConsigneeReducer, createConsigneeReducer, updateConsigneeReducer, deleteConsigneeReducer }